import React from 'react';
import Masthead from "./components/Masthead";
import Hero from "./components/Hero";
import {Box} from "@mui/material";
import Stars from "./components/Stars";
import Newsletter from "./components/Newsletter";
import Footer from "./components/Footer";
import Statement from "./components/Statement";
import Cookies from "./components/Cookies";

function App() {
    return (
        // clip phone
        <Box
            maxWidth={"100%"}
            sx={{overflowX: "hidden"}}
        >
            <Stars/>
            <Masthead/>
            <Hero/>
            <Statement/>
            <Newsletter/>
            <Footer/>
            <Cookies/>
        </Box>
    );
}

export default App;
